// The checker
const gambitGalleryIsInView = el => {
	const scroll = window.scrollY || window.pageYOffset
	const boundsTop = el.getBoundingClientRect().top + scroll
	
	const viewport = {
		top: scroll,
		bottom: scroll + window.innerHeight,
	}
	
    const bounds = {
		top: boundsTop,
		bottom: boundsTop + el.clientHeight,
	}
	
	return bounds.bottom >= viewport.top;
}


// Usage.
document.addEventListener( 'DOMContentLoaded', () => {
	const tester = document.querySelector( '.quantity-submit-row__submit' )
	
	const handler = () => raf( () => {
		if(gambitGalleryIsInView( tester )) {
      if(!document.querySelector('sticky-atc').classList.contains('sticky-atc--out')) {
        document.querySelector('sticky-atc').classList.add('sticky-atc--out');

      }
      if(!document.querySelector('sticky-atc').classList.contains('invisible')) {
        document.querySelector('sticky-atc').classList.add('invisible');

      }
    }
    else {
      if(document.querySelector('sticky-atc').classList.contains('sticky-atc--out')) {
        document.querySelector('sticky-atc').classList.remove('sticky-atc--out');
      }
      if(document.querySelector('sticky-atc').classList.contains('invisible')) {
        document.querySelector('sticky-atc').classList.remove('invisible');
      }
    }
	})
	
	handler()
	window.addEventListener( 'scroll', handler )
} )

// requestAnimationFrame
const raf = 
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  function( callback ) {
      window.setTimeout( callback, 1000 / 60 )
  }

  

document.querySelector('sticky-atc .add-to-cart').addEventListener('click', function() {
  document.querySelector('.quantity-submit-row__submit button[type="submit"]').click();
});

document.querySelectorAll('sticky-atc .js-option').forEach((ele) => {
  ele.addEventListener('click', function() {
    const value = this.dataset.value;
    const optionName = this.dataset.optionName;
    const inputLabel = document.querySelector(`.product-form [data-value="${value}"][data-option-name="${optionName}"]`);
    var input = document.getElementById(inputLabel.getAttribute('for'));
    console.log(input);
    if (input) {
      input.checked = true;
      input.dispatchEvent(
      new CustomEvent('change', { bubbles: true, cancelable: false }));

    }
  });
})

document.querySelectorAll('.product-form .opt-label').forEach((ele) => {
  ele.addEventListener('click', function() {
    const value = this.dataset.value;
    const optionName = this.dataset.optionName;
    document.querySelector(`sticky-atc [data-value="${value}"][data-option-name="${optionName}"]`).closest('.cc-select').dispatchEvent(new CustomEvent('selectOption', { detail: { value: value } }));
  });
})